import { Tooltip } from 'antd';
import React from 'react'
import styled from 'styled-components';
import { THEME } from './globalStyles';

/**
 * 
 * @param {Array<String>} options 
 * @param {String} selected 
 * @param {Function} onChange 
 * 
 */
export default function HorizontalSelector({options,selected,onChange,fontSize,cuantity,style,childStyle}){
  const length = options.length;
  return (
    <LinealSelect style={style}>
      {options.map((op,index)=>
        op.tooltip?(
          <Tooltip key={index} title={op.tooltip} color={THEME.colors.blue}>
            <LinealSelectButton 
              selected={op.value===selected} 
              fontSize={fontSize}
              withBorder={index<(length-1)} 
              onClick={()=>onChange(op)}
              style={{...(childStyle||{}),minWidth:op.minWidth}}
            >
              {op.text} {cuantity&&Number.isInteger(cuantity[index])&&`(${cuantity[index]})`}
            </LinealSelectButton>
          </Tooltip>
        ):(
          <LinealSelectButton 
            key={index}
            selected={op.value===selected} 
            fontSize={fontSize}
            withBorder={index<(length-1)} 
            onClick={()=>onChange(op)}
            style={{...(childStyle||{}),minWidth:op.minWidth}}
          >
            {op.text} {cuantity&&Number.isInteger(cuantity[index])&&`(${cuantity[index]})`}
          </LinealSelectButton>
        )
      )}
    </LinealSelect>
  )
}

const LinealSelect = styled.div`
  width: 100%;
  min-width: 180px;
  border-radius: 6px;
  border: 2px solid ${THEME.colors.ligthBlue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 12px;
  background-color: #FFF;
`;

const LinealSelectButton = styled.button`
  display: flex;
  flex:1;
  min-width: 45px;
  min-height: 35px;
  justify-content: center;
  align-items: center;
  color: ${THEME.colors.darkBlue};
  background: none;
  border: none;
  padding: 4px;
  border-right: ${p=>p.withBorder?'2px solid '+THEME.colors.ligthBlue:'none'};
  background-color: ${p=>p.selected?THEME.colors.ligthBlue:null};
  :hover{
    background-color: ${p=>p.selected?THEME.colors.ligthBlue+'aa':'#f9f9f9'};
  }
  font-size:${p=>p.fontSize||'1em'};
`;